import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMehr = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#289925'
      d='M8.476 2.155c3.091-.581 6.413.5 8.668 2.758a25.9 25.9 0 0 0-3.855 6.29c-.196.449-.339.923-.578 1.353-.695-1.37-1.608-2.658-2.857-3.535a6.17 6.17 0 0 0-3.318-1.174q-.256.008-.502.08c.233.5.539.96.727 1.483.545 1.453.786 3 1.211 4.49.392 1.426.953 2.823 1.817 4.015a10.3 10.3 0 0 0 2.672 2.546c.148.104.417.257.502 0 .12-.586.136-1.192.26-1.78.634-3.374 2.026-6.58 3.943-9.379 1.577-2.264 3.562-4.308 6.02-5.518.261-.114.52-.287.814-.27 0 .341-.251.606-.366.91-.749 1.684-1.13 3.505-1.572 5.293-.567 2.32-1.086 4.68-2.092 6.848-1.058 2.307-2.84 4.175-5.054 5.3-2.18 1.094-4.725 1.433-7.085.86-2.281-.551-4.308-1.904-5.735-3.829a10.75 10.75 0 0 1-2.09-6.726 10.7 10.7 0 0 1 2.5-6.575 10.05 10.05 0 0 1 5.96-3.441z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMehr)
export default ForwardRef
